import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/treatments/diagnosis-types/style'

/** API */
import DiagnosisTypeApi from 'api/setting/treatments/diagnosis-type.api'

/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}
const initStateErrorMessage = {
  DIAGNOSIS_TYPE_NAME: ``,
  IS_DUPLICATE_DIAGNOSIS_TYPE_NAME: ``,
  DIAGNOSIS_TYPE_NAME_STRING_BASE: ``,
  DIAGNOSIS_TYPE_NAME_STRING_EMPTY: ``,
  DIAGNOSIS_TYPE_NAME_MAXIMUM_LENGTH: ``,
  DIAGNOSIS_TYPE_NAME_ANY_REQUIRED: ``,

  DIAGNOSIS_TYPE_NAME_EN: ``,
  IS_DUPLICATE_DIAGNOSIS_TYPE_NAME_EN: ``,
  DIAGNOSIS_TYPE_NAME_EN_STRING_BASE: ``,
  DIAGNOSIS_TYPE_NAME_EN_STRING_EMPTY: ``,
  DIAGNOSIS_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
  DIAGNOSIS_TYPE_NAME_EN_ANY_REQUIRED: ``
}
export default function DiagnosisTypes() {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [diagnosisTypes, setDiagnosisTypes] = useState([])

  const [diagnosisTypeId, setDiagnosisTypeId] = useState(Number)
  const [diagnosisTypeName, setDiagnosisTypeName] = useState('')
  const [diagnosisTypeNameEn, setDiagnosisTypeNameEn] = useState('')
  const [diagnosisTypeStatus, setDiagnosisTypeStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)

  const [isOpen, setIsOpen] = useState(false)

  const loadData = async () => {
    try {
      const resp = await DiagnosisTypeApi.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setDiagnosisTypes(resp.data)
      } else {
        setDiagnosisTypes([])
      }
    } catch (error) {
      notiError('เกิดข้อผิดพลาด')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    setDisabledSubmit(true)
    if (!diagnosisTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ DIAGNOSIS_TYPE_NAME: t('DIAGNOSIS_TYPE.MESSAGE.DIAGNOSIS_TYPE_NAME') } })
    }

    dispatch(submitModal())
    DiagnosisTypeApi.create({ diagnosisTypeName, diagnosisTypeNameEn })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('DIAGNOSIS_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`DIAGNOSIS_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`DIAGNOSIS_TYPE.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    if (!diagnosisTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ DIAGNOSIS_TYPE_NAME: t(`DIAGNOSIS_TYPE.MESSAGE.DIAGNOSIS_TYPE_NAME`) } })
    }

    dispatch(submitModal())
    DiagnosisTypeApi.update(diagnosisTypeId, {
      diagnosisTypeName,
      diagnosisTypeNameEn,
      status: diagnosisTypeStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`DIAGNOSIS_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`DIAGNOSIS_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`DIAGNOSIS_TYPE.MESSAGE.${err.message}`) } })
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setDiagnosisTypeId(0)
    setDiagnosisTypeName('')
    setDiagnosisTypeNameEn('')
    setDiagnosisTypeStatus('')
    clearErrorMessage()
    setIsOpen(false)
  }

  const onActive = () => {
    if (id) {
      DiagnosisTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('DIAGNOSIS_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('DIAGNOSIS_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = async () => {
    if (id) {
      DiagnosisTypeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('DIAGNOSIS_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('DIAGNOSIS_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { diagnosisTypeId: dgoTypeId, diagnosisTypeName: dgoTypeName, diagnosisTypeNameEn: dgoTypeNameEn, status: dgoTypeStatus } = data
    setDiagnosisTypeId(dgoTypeId)
    setDiagnosisTypeName(dgoTypeName)
    setDiagnosisTypeNameEn(dgoTypeNameEn)
    setDiagnosisTypeStatus(dgoTypeStatus)
    setIsOpen(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'diagnosisTypeName', disablePadding: false, label: t('DIAGNOSIS_TYPE.TABLE.CELL.DIAGNOSIS_TYPE_NAME') },
    { id: 'diagnosisTypeNameEn', disablePadding: false, label: t('DIAGNOSIS_TYPE.TABLE.CELL.DIAGNOSIS_TYPE_NAME_EN') },
    { id: 'status', disablePadding: false, label: t('DIAGNOSIS_TYPE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('DIAGNOSIS_TYPE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { diagnosisTypeId: dgoTypeId, diagnosisTypeName: dgoTypeName, diagnosisTypeNameEn: dgoTypeNameEn, updatedBy, updatedAt, status: dgoTypeStatus } = objData
    const statusBtnActive = dgoTypeStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = dgoTypeStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: dgoTypeId,
      id: dgoTypeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: dgoTypeName },
        { option: 'TEXT', align: 'left', label: dgoTypeNameEn },
        { option: 'STATUS', align: 'center', label: dgoTypeStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.diagnosisTypeName)
    setNameEn(obj.diagnosisTypeNameEn)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`DIAGNOSIS_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`DIAGNOSIS_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { diagnosisTypeName: name, diagnosisTypeNameEn: nameEn && `(${nameEn})`, status: t(`DIAGNOSIS_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <PageModal
        title={diagnosisTypeId ? t('DIAGNOSIS_TYPE.TITLE_UPDATE') : t('DIAGNOSIS_TYPE.TITLE_CREATE')}
        size='XS'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('DIAGNOSIS_TYPE.BUTTON.CANCEL') }}
        onSubmit={{ onClick: diagnosisTypeId ? submitEdit : submit, title: t('DIAGNOSIS_TYPE.BUTTON.SAVE'), disabled: disabledSubmit }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          {diagnosisTypeId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
            <SwitchButton onChange={() => setDiagnosisTypeStatus(diagnosisTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={diagnosisTypeStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              setDiagnosisTypeName(event.target.value)
              clearErrorMessage()
            }}
            value={diagnosisTypeName}
            label={t('DIAGNOSIS_TYPE.INPUT.DIAGNOSIS_TYPE_NAME')}
            helperText={
              errorMessage.DIAGNOSIS_TYPE_NAME ||
              errorMessage.IS_DUPLICATE_DIAGNOSIS_TYPE_NAME ||
              errorMessage.DIAGNOSIS_TYPE_NAME_STRING_BASE ||
              errorMessage.DIAGNOSIS_TYPE_NAME_STRING_EMPTY ||
              errorMessage.DIAGNOSIS_TYPE_NAME_MAXIMUM_LENGTH ||
              errorMessage.DIAGNOSIS_TYPE_NAME_ANY_REQUIRED
            }
            required
          />
          <TextInput
            onChange={(event) => {
              setDiagnosisTypeNameEn(event.target.value)
              clearErrorMessage()
            }}
            value={diagnosisTypeNameEn}
            helperText={
              errorMessage.DIAGNOSIS_TYPE_NAME_EN ||
              errorMessage.IS_DUPLICATE_DIAGNOSIS_TYPE_NAME_EN ||
              errorMessage.DIAGNOSIS_TYPE_NAME_EN_STRING_BASE ||
              errorMessage.DIAGNOSIS_TYPE_NAME_EN_STRING_EMPTY ||
              errorMessage.DIAGNOSIS_TYPE_NAME_EN_MAXIMUM_LENGTH ||
              errorMessage.DIAGNOSIS_TYPE_NAME_EN_ANY_REQUIRED
            }
            label={t('DIAGNOSIS_TYPE.INPUT.DIAGNOSIS_TYPE_NAME_EN')}
          />
        </Box>
      </PageModal>
      <HeaderCard text={t('DIAGNOSIS_TYPE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={2}>
            <TextInput
              label={t('DIAGNOSIS_TYPE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={1}>
            <MainButton
              title={t('INPUT.SEARCH')}
              type='primary'
              variant='contained'
              style={{ width: '100%' }}
              onClick={() => {
                setPage(1)
                loadData()
              }} />

          </Grid>
          <Grid item xs={7} textAlign="right">
            <MainButton title={t('DIAGNOSIS_TYPE.BUTTON.ADD')} disabled={permissions.isCreate.disabled} type='primary' variant='contained' onClick={() => setIsOpen(true)} startIcon={<AddCircleIcon />} />
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={diagnosisTypes.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
      </Box>
    </Box>
  )
}
